import { API_BASE, getAuthHeaders } from './config';

export type ErrorReport = {
    id: string;
    content_id: string | null;
    profile_id: string | null;
    user_id?: string | null;
    type: 'TEXT' | 'AUDIO' | 'APP';
    description: string;
    reported_at: string;
    is_resolved: boolean;
    user_email?: string | null;
    profile_name?: string | null;
    content_title?: string | null;
    content_type?: string | null;
};

export async function adminFetchErrorReports(params?: {
    type?: '' | 'TEXT' | 'AUDIO' | 'APP';
    resolved?: 'any' | 'true' | 'false';
    q?: string;
    page?: number;
    limit?: number;
}) {
    const qp = new URLSearchParams();
    if (params?.type) qp.set('type', params.type);
    if (params?.resolved) qp.set('resolved', params.resolved);
    if (params?.q) qp.set('q', params.q);
    if (params?.page) qp.set('page', String(params.page));
    if (params?.limit) qp.set('limit', String(params.limit));

    const res = await fetch(`${API_BASE}/admin/error-reports?${qp.toString()}`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<{ items: ErrorReport[]; total: number; page: number; limit: number; pending: number }>;
}

export async function adminGetErrorReport(id: string) {
    const res = await fetch(`${API_BASE}/admin/error-reports/${id}`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<ErrorReport>;
}

export async function adminUpdateErrorReport(id: string, payload: { is_resolved: boolean }) {
    const res = await fetch(`${API_BASE}/admin/error-reports/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<ErrorReport>;
}

export async function createErrorReport(payload: {
    type: 'TEXT' | 'AUDIO' | 'APP';
    description: string;
    content_id?: number | string | null;
    profile_id?: number | string | null;
}) {
    const res = await fetch(`${API_BASE}/error-reports`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}

export async function adminCreateErrorReport(payload: {
    type: 'TEXT' | 'AUDIO' | 'APP';
    description: string;
    content_id?: number | string | null;
}) {
    const res = await fetch(`${API_BASE}/admin/error-reports`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}
